import {
  Button,
  message,
  Space,
  type TableColumnsType,
  Typography,
} from 'antd';
import moment from 'moment';
import React from 'react';

import { getAxiosWithAuth } from '@/lib/axios';

import ImageButton from './ImageButton';
import type { FixTableData, GetColumnsArgs, ShowModalType } from './types';

export const getTitle = (
  type: ShowModalType,
  fixTableData: FixTableData | null
) => {
  let title = '';
  switch (type) {
    case 'edit':
      title = '編輯報修單';
      break;
    case 'view':
      title = '查看報修單';
      break;
    case 'message':
      title = '報修訊息';
      if (fixTableData) {
        title = `${fixTableData.householdNumber} - ${fixTableData.title}`;
      }
      break;
    default:
      title = '新增報修單';
      break;
  }
  return title;
};

export const emitMsgToResident = async (
  householdNumber: string,
  title: string
) => {
  const axios = getAxiosWithAuth();
  try {
    await axios('/ezcon/api/emitMsgQuery', {
      method: 'POST',
      data: {
        service: 'message',
        event: 'msg',
        title: '報修通知',
        content: `${householdNumber}住戶您好,處理項目:${title},維修人員即將到府服務,如有問題請洽管理員`,
        type: 'success',
        class: 'fix',
        duration: 8000,
        redirect: '/ezpro/fix/fixFrontDesk',
        query: {
          householdNumbers: {
            $in: [householdNumber],
          },
          firebaseClass: '報修服務',
        },
      },
    });
    message.success('已傳送推播給住戶');
  } catch (error) {
    console.error(error);
    message.error('已傳送推播給住戶失敗');
  }
};

export const getColumns = ({ onEdit, onView, onMessage }: GetColumnsArgs) => {
  const columns: TableColumnsType<FixTableData> = [
    {
      dataIndex: 'createdTime',
      title: '建立時間',
      fixed: 'left',
      render: (createdTime) => moment(createdTime).format('YYYY-MM-DD HH:mm'),
      sorter: (a, b) => a.createdTime.localeCompare(b.createdTime),
      sortDirections: ['descend', 'ascend', 'descend'],
    },
    {
      dataIndex: 'serialNumber',
      title: '編號',
      width: 100,
    },
    {
      dataIndex: 'householdNumber',
      title: '戶號',
      sorter: (a, b) => a.householdNumber.localeCompare(b.householdNumber),
      sortDirections: ['descend', 'ascend', 'descend'],
    },
    {
      dataIndex: 'category',
      title: '區域',
      render: (category) => category.name,
      sorter: (a, b) => a.category.name.localeCompare(b.category.name),
      sortDirections: ['descend', 'ascend', 'descend'],
    },
    {
      dataIndex: 'title',
      title: '標題',
    },
    {
      dataIndex: 'status',
      title: '狀態',
      sorter: (a, b) => a.status.localeCompare(b.status),
      sortDirections: ['descend', 'ascend', 'descend'],
    },
    {
      dataIndex: 'image',
      title: '照片',
      render: (image) =>
        image ? (
          <ImageButton src={image.path} />
        ) : (
          <Typography>無照片</Typography>
        ),
    },
    {
      dataIndex: 'updatedTime',
      title: '更新時間',
      render: (updatedTime) => moment(updatedTime).format('YYYY-MM-DD HH:mm'),
    },
    {
      dataIndex: '_id',
      title: '操作',
      fixed: 'right',
      render: (_, fixData) => (
        <Space onClick={(e) => e.stopPropagation()}>
          <Button onClick={() => onEdit(fixData)}>編輯</Button>
          <Button onClick={() => onView(fixData)}>維修紀錄</Button>
          <Button onClick={() => onMessage(fixData)}>訊息</Button>
          <Button
            onClick={() =>
              emitMsgToResident(fixData.householdNumber, fixData.title)
            }
          >
            通知住戶
          </Button>
        </Space>
      ),
    },
  ];

  return columns;
};
